import { NgClass } from '@angular/common'
import { Component, computed, input } from '@angular/core'

@Component({
  selector: 'progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
  imports: [NgClass],
  standalone: true
})
export class ProgressCircleComponent {
  /**
   * Input signal for upload progress percentage (0-100)
   */
  protected readonly _uploadProgress = input<number>()
  protected readonly colorClasses = input<string>('tw-border-blue-600 tw-border-r-gray-300')

  get uploadProgress(): number {
    return this._uploadProgress()
  }

  /**
   * Input signal to determine if progress circle should show infinite loading animation
   * @default true
   */
  protected readonly _isInfinite = input<boolean>(true)

  get isInfinite(): boolean {
    return this._isInfinite()
  }

  /**
   * Computed signal that converts upload progress to stroke-dashoffset value
   * Formula: 200 - (progress * 2) gives values from 200 (0%) to 0 (100%)
   */
  progressValue = computed(() => 200 - this.uploadProgress * 2)
}
